module.exports = __webpack_public_path__ + "img/ploutus-holdings.c941b419.webp";